import { render } from "./DeleteCandidateUser.vue?vue&type=template&id=3b8f1d87&scoped=true"
import script from "./DeleteCandidateUser.vue?vue&type=script&lang=js"
export * from "./DeleteCandidateUser.vue?vue&type=script&lang=js"

import "../css/deleteCandidate.css?vue&type=style&index=0&id=3b8f1d87&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8f1d87"]])

export default __exports__